import React from "react";
import '../../resources/css/application.css';
import iconError from "../../resources/images/icon-error-1.svg";
import Header from "../common/Header";
import Footer from "../common/Footer";

function ErrorPage() {

  return (
    <div className="site">

      <Header headerTextFlag={false}/>

      <main className="site-content">

        <div className="container">

          <div className="card card--pullup card--content-center text-center">

            <div className="icon-benefit mb-4">
              <img alt="" src={iconError}/>
            </div>

            <h1 className="headline-1 w-md-75">Neuspješno slanje dokumenata</h1>
            <p className="lead mb-5 w-md-75">Molimo Vas da se javite u poslovnicu banke.</p>

          </div>
        </div>

      </main>

      <Footer/>

    </div>
  );
}

export default ErrorPage;